export const FriendStatus = {
    pending: "pending",
    confirmed: "confirmed",
};